import React from 'react';
import { useLocation } from 'react-router-dom';

export const NewTankExternalPage = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const returnUrl = searchParams.get('returnUrl') || '';

    return (
        <iframe
            style={{ width: '100%', height: '100%' }}
            src={`/embed/tanks/new?returnUrl=${encodeURIComponent(returnUrl)}`}
        />
    );
};
